import { Box, Stack, Typography } from '@mui/material';

import { BackButton } from '@/ui/components/button/BackButton';

export function PageTitle({
  title,
  subtitle,
  backButtonText,
  onClickBack,
  rightComponent,
}: {
  title: string;
  subtitle?: string;
  backButtonText: string;
  onClickBack: () => void;
  rightComponent?: React.ReactNode;
}) {
  return (
    <Stack>
      <BackButton onClick={onClickBack} text={backButtonText} />
      <Stack sx={{ flexDirection: 'row', flexWrap: 'wrap', gap: 2 }}>
        <Stack sx={{ gap: 2 }}>
          <Typography variant="h5">{title}</Typography>
          <Typography variant="body1">{subtitle}</Typography>
        </Stack>
        <Box sx={{ marginLeft: 'auto' }}>{rightComponent}</Box>
      </Stack>
    </Stack>
  );
}
